/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  CreateChainContactRequestJobMutationRequest,
  CreateChainContactRequestJobMutationResponse,
  CreateChainContactRequestJob400,
} from '../types/CreateChainContactRequestJob'

function getCreateChainContactRequestJobUrl() {
  const res = { method: 'POST', url: `/api/v1/contact_request/chain/` as const }
  return res
}

/**
 * @description Resolve contact-request select-all through the unified opps queryset.
 * Mixed in ahead of ``CreateContactRequestJobView`` + ``UnifiedOppsView`` so the
 * select-all set is re-resolved by the SAME engine that renders the table
 * (unified row ``id`` == chain-proxy id), replacing each vertical's legacy
 * list-view filterset. The vertical is pinned server-side via
 * ``contact_request_target_type`` (the endpoint IS the vertical) rather than
 * trusted from the client, so a missing/wrong client ``target_type`` can never
 * resolve contacts for another vertical. The client still sends the unified
 * filter params (adapted like the list request) so the resolved set matches the
 * rows the user saw.
 * @summary Create a contact request job for restaurant/bar chains
 * {@link /api/v1/contact_request/chain/}
 */
export async function createChainContactRequestJob(
  data: CreateChainContactRequestJobMutationRequest,
  config: Partial<
    RequestConfig<CreateChainContactRequestJobMutationRequest>
  > & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateChainContactRequestJobMutationResponse,
    ResponseErrorConfig<CreateChainContactRequestJob400>,
    CreateChainContactRequestJobMutationRequest
  >({
    method: 'POST',
    url: getCreateChainContactRequestJobUrl().url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
